export const setInTransition = (innerRefScrollHeight: any) =>
  innerRefScrollHeight !== 0;
